import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const OpenBookIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.75 1C1.33579 1 1 1.33579 1 1.75V15.25C1 15.6642 1.33579 16 1.75 16H7C8.24264 16 9.25 17.0074 9.25 18.25C9.25 18.6642 9.58579 19 10 19C10.4142 19 10.75 18.6642 10.75 18.25C10.75 17.0074 11.7574 16 13 16H18.25C18.6642 16 19 15.6642 19 15.25V1.75C19 1.33579 18.6642 1 18.25 1H13C11.7733 1 10.6842 1.58901 10 2.49964C9.31583 1.58901 8.2267 1 7 1H1.75ZM9.25 4.75C9.25 3.50736 8.24264 2.5 7 2.5H2.5V14.5H7C7.8442 14.5 8.62325 14.779 9.25 15.2497V4.75ZM10.75 15.2497V4.75C10.75 3.50736 11.7574 2.5 13 2.5H17.5V14.5H13C12.1558 14.5 11.3767 14.779 10.75 15.2497Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
